import { showSurgeryCenterV2 } from '@/utils/permissionsHelp'

// Exclusividade (ADR-006): com a flag centro-cirurgico-v2 ligada na clínica,
// as telas do CC v1 (/centro-cirurgico-new) redirecionam para o Painel
// cirúrgico (React). Sem a flag, o v1 segue normal.
const redirectIfV2 = (to, from, next) =>
  showSurgeryCenterV2() ? next('/tracker-board/') : next()

const moduleRoute = {
  path: '/centro-cirurgico-new',
  component: () => import('@/views/Home.vue'),
  children: [
    {
      path: '',
      component: () => import('./views/Home.vue'),
      children: [
        {
          path: '',
          component: () => import('./views/SurgeryMap.vue'),
          beforeEnter: redirectIfV2
        },
        {
          path: 'mapa-cirurgico',
          component: () => import('./views/SurgeryMap.vue'),
          beforeEnter: redirectIfV2
        },
        {
          path: 'cirurgias/:tab?',
          component: () => import('./views/Surgeries.vue'),
          beforeEnter: redirectIfV2
        }
      ]
    }
  ]
}

export default router => {
  router.addRoute(moduleRoute)
}
